<mat-icon color="warn">error</mat-icon>
<span class="data">{{ error }}</span>
